import React from 'react'
import { Popover } from 'components/Overlay'
import { User } from 'components/User'
import { connect } from 'react-redux'

import { userLogOutRequest } from '../../actions'

const UserProfilePopover = ({
	closePortal,
	requestUserLogOut,
	name,
	login,
	licence,
	avatar
}) => {
	return (
		<Popover
			light
			modifiers={{
				hide: { enabled: true },
				preventOverflow: {
					enabled: true
				}
			}}
		>
			<User
				name={name}
				login={login}
				avatar={avatar}
				licence={licence}
				requestUserLogOut={requestUserLogOut}
			/>
		</Popover>
	)
}

UserProfilePopover.propTypes = {
	closePortal: React.PropTypes.func
}

const mapStateToProps = (state, ownProps) => {
	return {
		name: state.user.meta.name,
		login: state.user.meta.login,
		avatar: state.user.meta.avatar,
		licence: state.user.meta.license_id
	}
}
const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		requestUserLogOut: () => {
			dispatch(userLogOutRequest())
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserProfilePopover)



// WEBPACK FOOTER //
// ./src/views/Popovers/UserProfilePopover.js